import * as React from "react";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import styles from '../css/gis.module.css';

// 전체 체크박스 그룹을 관리하는 컨테이너 컴포넌트
export default function GisLayerCheck({selLayerList, setLayerList, layerIndex, allLayerList, setAllLayerList, setSelectedLayer, }) {

  const handleChange = (e, i) => {
    let tmpLayerList = [...selLayerList];
    tmpLayerList[i].checked = e.target.checked;    
    setLayerList(tmpLayerList);
    setSelectedLayer(tmpLayerList[i]);

    let tmpAllLayerList = [...allLayerList];
    for(let i = 0; i < tmpLayerList.length; i ++) {      
      let index = tmpAllLayerList.findIndex(x => x.layer === tmpLayerList[i].layer);
      if(index < 0) {
        debugger
      } else {
        tmpAllLayerList[index] = tmpLayerList[i];
      }
    }
    // CCTV 체크 상태를 접근로 레이어에도 동일하게 적용
  if (tmpLayerList[i].layer === 'cctvLayer') {
    const accessCctvIndex = tmpAllLayerList.findIndex(
      x => x.layer === 'accessCctvLayer'
    );

    if (accessCctvIndex >= 0) {
      tmpAllLayerList[accessCctvIndex] = {
        ...tmpAllLayerList[accessCctvIndex],
        checked: e.target.checked,
      };
    }
  }
    setAllLayerList(tmpAllLayerList);    
  };

  return (
    <Box sx={{ display: "flex", }}>
      <FormGroup className={`${styles.chkBox} ${styles[`chkBox_${layerIndex}`]}`}>
        {selLayerList.map((v, i) => 
          v.display !== 'none' && (
          <FormControlLabel
            key={i}
            control={
              <Checkbox 
                id={v.layer} 
                name={v.label} 
                onChange={(e) => handleChange(e, i)} 
                checked={v.checked}
                disabled={v.disabled}
              />
            }
            label={v.label}
          />            
        ))}
      </FormGroup>
    </Box>
  );
}